import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import WarehouseAssortmentCreationComponent from "./component";
import { useParams, useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';

const WarehouseAssortmentCreationContainer = (props) => {
  const navigate = useNavigate();
  const { reference_id, assortmentId, ruleId } = useParams();
  const [showEndRuleModal, setShowEndRuleModal] = useState(false);
  const [selectedRuleToEnd, setSelectedRuleToEnd] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [assortmentWarehouseMetaDataDetails, setAssortmentWarehouseMetaDataDetails] = useState();
  const [assortmentWarehouseMetaDataDetailsList, setAssortmentWarehouseMetaDataDetailsList] = useState();
  const [assortmentWarehouseMetaDataRuleDetailsList, setAssortmentWarehouseMetaDataRuleDetailsList] = useState();
  const [assortmentWarehouseMachinesDetailsList, setAssortmentWarehouseMachinesDetailsList] = useState();
  const [selectedTab, setSelectedTab] = useState("assortments");
  const [rulesLoaded, setRulesLoaded] = useState(false);
  const [selectedHardwareType, setSelectedHardwareType] = useState(null);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);


    if (tab === "rules" && !rulesLoaded) {
      handleAssortmentWarehouseRuleDetailsList();
      setRulesLoaded(true);
    }
  };

  const handleAssortmentWarehouseDetails = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/warehouse/${reference_id}/metadata`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataDetails(response);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentWarehouseDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/warehouse/${reference_id}/all`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataDetailsList(response);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentWarehouseRuleDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/warehouse/${reference_id}/all`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataRuleDetailsList(response);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentWarehouseMachinesDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/warehouse/${reference_id}/machine/details`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMachinesDetailsList(response);
        // Set the first hardware type as selected by default
        if (response && response.length > 0) {
          setSelectedHardwareType(response[0].hardwareTypeId);
        }
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  useEffect(() => {
    handleAssortmentWarehouseMachinesDetailsList()
  }, [])

  const handleOpenEndRuleModal = (ruleId) => {
    setSelectedRuleToEnd(ruleId);
    setShowEndRuleModal(true);
  };

  const handleCloseEndRuleModal = () => {
    setShowEndRuleModal(false);
    setSelectedRuleToEnd(null);
    setEndDate("");
  };

 const handleEndRuleConfirm = () => {
  if (!endDate) {
    console.error("End date is required");
    return;
  }

  setLoading(true);

 
  

  props.getDataFromAPI(
    `/partner/api/v1/assortment/rule/inactive/${selectedRuleToEnd}/${endDate}`,
    "PUT",
    undefined,
    (response) => {
      console.log("Rule ended successfully");
      handleCloseEndRuleModal();
      handleAssortmentWarehouseRuleDetailsList();
    },
    (err) => {
      console.error("API Error:", err);
      setLoading(false);
    }
  );
};



  const handleAssortmentDetails = (assortmentId) => {
    navigate(`/home/assortment/assortmentdetails/${assortmentId}`);
  };

  const handleAssortmentRuleDetails = (ruleId) => {
    navigate(`/home/assortment/assortmentdetails/${ruleId}`);
  };

  const handleCreateNewAssortment = () => {
    navigate(`/home/assortment/newassortmentwarehousecreation/${reference_id}`);
  };

  const handleCreateNewRule = () => {
    navigate(`/home/assortment/newassortmentrulecreation/${reference_id}`);
  };

  const handleRuleUpdate = (ruleId) => {
    navigate(`/home/assortment/warehouse/rule/edit/${ruleId}`);
  };

  const handleCreateNewMachine = () => {
    navigate("/home/assortment/newmachinecreation");
  };

  useEffect(() => {
    handleAssortmentWarehouseDetails();
    handleAssortmentWarehouseDetailsList();

  }, []);

  return (
    <WarehouseAssortmentCreationComponent
      loading={loading}
      assortmentWarehouseMetaDataDetails={assortmentWarehouseMetaDataDetails}
      assortmentWarehouseMetaDataDetailsList={assortmentWarehouseMetaDataDetailsList}
      assortmentWarehouseMetaDataRuleDetailsList={assortmentWarehouseMetaDataRuleDetailsList}
      showEndRuleModal={showEndRuleModal}
      endDate={endDate}
      onEndDateChange={setEndDate}
      onCloseEndRuleModal={handleCloseEndRuleModal}
      onEndRuleConfirm={handleEndRuleConfirm}
      onAssortmentDetails={handleAssortmentDetails}
      onAssortmentRuleDetails={handleAssortmentRuleDetails}
      onAssortmentRuleRemove={handleOpenEndRuleModal}
      onCreateNewAssortment={handleCreateNewAssortment}
      onCreateNewRule={handleCreateNewRule}
      onCreateNewMachine={handleCreateNewMachine}
      handleCreateNewRuleUpdate={handleRuleUpdate}
      selectedTab={selectedTab}
      onTabChange={handleTabChange}
      selectedHardwareType={selectedHardwareType}
      setSelectedHardwareType={setSelectedHardwareType}
      assortmentWarehouseMachinesDetailsList={assortmentWarehouseMachinesDetailsList}
    />
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, { getDataFromAPI })(WarehouseAssortmentCreationContainer); 
